// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { ProductCardFragmentDoc, ProductCardRingBuilderMountPriceFragmentDoc } from '../layout/cards/ProductCard.fragment.generated';
import { ProductLinkFragmentDoc } from '../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from './MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../monolithImageSize.fragment.generated';
export const RelatedProductFragmentDoc = `
    fragment relatedProduct on CatalogueProduct {
  ...productCard
  ... on CatalogueEngagementRing {
    variationsByPrimaryMetal {
      ...productCard
    }
  }
  ... on CatalogueWeddingRing {
    variations {
      ...productCard
    }
  }
  ... on CatalogueJewelleryRing {
    variations {
      ...productCard
    }
  }
  ... on CatalogueJewelleryBracelet {
    variations {
      ...productCard
    }
  }
  ... on CatalogueJewelleryNecklace {
    variations {
      ...productCard
    }
  }
  ... on CatalogueJewelleryEarrings {
    variations {
      ...productCard
    }
  }
}
    `;